const c = {
  name: "Instagram",
  dimensions: { width: 40, height: 40 },
  content: `
<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 40 40" style="enable-background:new 0 0 40 40;" xml:space="preserve">
<style type="text/css">
	.st0{fill-rule:evenodd;clip-rule:evenodd;fill: currentColor;}
</style>
<path class="st0" d="M24.9,20c0-2.7-2.2-4.9-4.9-4.9c-2.7,0-4.9,2.2-4.9,4.9c0,2.7,2.2,4.9,4.9,4.9C22.7,24.9,24.9,22.7,24.9,20z"/>
<path class="st0" d="M19.5,7.9c-0.3,0-0.6,0-0.8,0v0c-2.8,0-3.3,0-4.6,0.1c-1.4,0.1-2.2,0.3-2.7,0.5c-0.7,0.3-1.2,0.6-1.7,1.1
	c-0.5,0.5-0.8,1-1.1,1.7C8.3,11.8,8,12.6,8,14c-0.1,1.6-0.1,2-0.1,6s0,4.4,0.1,6c0.1,1.4,0.3,2.2,0.5,2.7c0.3,0.7,0.6,1.2,1.1,1.7
	c0.5,0.5,1,0.8,1.7,1.1c0.5,0.2,1.3,0.4,2.7,0.5c1.6,0.1,2,0.1,6,0.1c3.9,0,4.4,0,6-0.1c1.4-0.1,2.2-0.3,2.7-0.5
	c0.7-0.3,1.2-0.6,1.7-1.1c0.5-0.5,0.8-1,1.1-1.7c0.2-0.5,0.4-1.3,0.5-2.7c0.1-1.6,0.1-2,0.1-6s0-4.4-0.1-6c-0.1-1.4-0.3-2.2-0.5-2.7
	c-0.3-0.7-0.6-1.2-1.1-1.7c-0.5-0.5-1-0.8-1.7-1.1C28.2,8.3,27.4,8,26,8c-1.6-0.1-2-0.1-6-0.1C19.8,7.9,19.7,7.9,19.5,7.9z
	 M26.1,12.1c0-1,0.8-1.8,1.8-1.8s1.8,0.8,1.8,1.8c0,1-0.8,1.8-1.8,1.8S26.1,13.1,26.1,12.1z M12.4,20c0-4.2,3.4-7.6,7.6-7.6
	c4.2,0,7.6,3.4,7.6,7.6s-3.4,7.6-7.6,7.6S12.4,24.2,12.4,20z"/>
<path class="st0" d="M8.7,0C9.2,0,11.7,0,20,0h6.5c4.7,0,5,0,5.8,0.2l0.1,0c1.9,0.3,3.5,1,4.9,2.3C38,3.2,38.5,3.9,39,4.8
	c0.6,1.1,0.8,2.2,1,3.8c0,0.3,0,5.8,0,11.3c0,5.5,0,11,0,11.3c-0.1,1.6-0.4,2.7-0.9,3.8c-1.1,2.2-3.1,3.9-5.5,4.5
	c-0.9,0.2-1.7,0.3-3,0.4c-0.5,0-5.5,0-10.6,0c-5.1,0-10.1,0-10.6,0c-1.2-0.1-2.1-0.2-2.9-0.4C4.1,39,2.1,37.3,1,35.1
	c-0.6-1.1-0.8-2.2-1-3.9c0-0.5,0-2.9,0-11.3c0-1,0-2,0-2.8c0-1.5,0-2.7,0-3.7c0-4.7,0-5,0.2-5.9c0,0,0,0,0,0c0.3-1.9,1-3.5,2.3-4.9
	C3.2,2,3.9,1.5,4.8,1C6,0.5,7,0.2,8.7,0z M13.9,5.3C15.5,5.2,16,5.2,20,5.2h0c4,0,4.5,0,6.1,0.1c1.6,0.1,2.6,0.3,3.6,0.7
	c1,0.4,1.8,0.9,2.6,1.7c0.8,0.8,1.3,1.6,1.7,2.6c0.4,0.9,0.6,2,0.7,3.6c0.1,1.6,0.1,2.1,0.1,6.1s0,4.5-0.1,6.1
	c-0.1,1.6-0.3,2.6-0.7,3.6c-0.4,1-0.9,1.8-1.7,2.6c-0.8,0.8-1.6,1.3-2.6,1.7c-0.9,0.4-2,0.6-3.6,0.7c-1.6,0.1-2.1,0.1-6.1,0.1
	c-4,0-4.5,0-6.1-0.1c-1.6-0.1-2.6-0.3-3.6-0.7c-1-0.4-1.8-0.9-2.6-1.7c-0.8-0.8-1.3-1.6-1.7-2.6c-0.4-0.9-0.6-2-0.7-3.6
	C5.2,24.5,5.2,24,5.2,20s0-4.5,0.1-6.1c0.1-1.6,0.3-2.6,0.7-3.6c0.4-1,0.9-1.8,1.7-2.6C8.5,6.9,9.4,6.4,10.3,6
	C11.3,5.6,12.3,5.4,13.9,5.3z"/>
</svg>
  `
};
export {
  c as Instagram
};
